import React from 'react';
import { ChevronDown } from 'lucide-react';

interface PrioritySelectorProps {
  value: 'high' | 'medium' | 'low' | null;
  onChange: (priority: 'high' | 'medium' | 'low' | null) => void;
  className?: string;
}

const PrioritySelector: React.FC<PrioritySelectorProps> = ({ value, onChange, className = '' }) => {
  const getPriorityColor = (priority: 'high' | 'medium' | 'low' | null) => {
    switch (priority) {
      case 'high':
        return 'bg-red-100 text-red-800 border-red-200 dark:bg-red-900/20 dark:text-red-400 dark:border-red-800';
      case 'medium':
        return 'bg-yellow-100 text-yellow-800 border-yellow-200 dark:bg-yellow-900/20 dark:text-yellow-400 dark:border-yellow-800';
      case 'low':
        return 'bg-green-100 text-green-800 border-green-200 dark:bg-green-900/20 dark:text-green-400 dark:border-green-800';
      default:
        return 'bg-transparent text-gray-500 border-gray-300 dark:text-gray-400 dark:border-gray-600';
    }
  };

  const getPriorityText = (priority: 'high' | 'medium' | 'low' | null) => {
    switch (priority) {
      case 'high':
        return 'Alta';
      case 'medium':
        return 'Media';
      case 'low':
        return 'Baja';
      default:
        return 'Sin prioridad';
    }
  };

  const getPriorityIcon = (priority: 'high' | 'medium' | 'low' | null) => {
    switch (priority) {
      case 'high':
        return '🔴';
      case 'medium':
        return '🟡';
      case 'low':
        return '🟢';
      default:
        return '⚪';
    }
  };

  return (
    <div className={`relative ${className}`}>
      <select
        value={value || ''}
        onChange={(e) => onChange(e.target.value === '' ? null : e.target.value as 'high' | 'medium' | 'low')}
        className={`appearance-none px-3 py-1.5 text-sm font-medium border rounded-md cursor-pointer focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors ${getPriorityColor(value)}`}
      >
        <option value="">Sin prioridad</option>
        <option value="high">Alta</option>
        <option value="medium">Media</option>
        <option value="low">Baja</option>
      </select>
      <ChevronDown className="absolute right-2 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-500 pointer-events-none" />
    </div>
  );
};

export default PrioritySelector;
